import {ReactNode} from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import {resolveLoanRoute} from './loanRoutePolicy';

export function WorkflowLoading() {
    return (
        <div role="status" className="p-5 text-center">
            در حال بررسی وضعیت درخواست…
        </div>
    );
}

export function WorkflowError({retry}: {retry: () => void}) {
    return (
        <div role="alert" className="p-5 text-center">
            <p>وضعیت درخواست قابل دریافت نیست. لطفاً دوباره تلاش کنید.</p>
            <button type="button" onClick={retry}>
                تلاش مجدد
            </button>
        </div>
    );
}

export default function LoanWorkflowGuard({
    status,
    pending,
    error,
    retry,
    availableForms,
    creation,
    children,
}: {
    status: string;
    pending: boolean;
    error: boolean;
    retry: () => void;
    availableForms?: string[];
    children: ReactNode;
    creation?: {templateSelected: boolean; calculationReady: boolean};
}) {
    const {pathname} = useLocation();
    if (pending) return <WorkflowLoading />;
    const target = resolveLoanRoute(status, pathname, availableForms, creation);
    if (error || target === null) return <WorkflowError retry={retry} />;
    if (target !== pathname.replace(/\/+$/, ''))
        return <Navigate to={target} replace />;
    return <>{children}</>;
}
